import { render, staticRenderFns } from "./LicensesOverviewItem.vue?vue&type=template&id=d32e7984&"
import script from "./LicensesOverviewItem.vue?vue&type=script&lang=js&"
export * from "./LicensesOverviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports